module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_9006.483d97eb.png";